import React from "react";
export default function PageNotFound() {
  return (
    <h1 className="min-h-[70%] flex justify-center items-center text-4xl text-center">
      404
      <br />
      Page Not found
    </h1>
  );
}
